<script setup lang="ts">
import { PV } from "@/widgets";
import { RouterLink } from "vue-router";

const props = defineProps<{
    to: string;
    label?: string;
}>();
</script>

<template>
    <RouterLink :to="props.to">
        <PV.Button icon="pi pi-plus" :label="props.label ?? 'Tambah'" size="small" text />
    </RouterLink>
</template>
